// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';
import { buildThemeAssetUrl } from '../../utils/themeAssetUrl';

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState("/game");
  const adminToken = useSelector(selectAdminToken);

  useEffect(() => {
    if (!themeData) return;

    setRedirect("/game");
  }, [themeData]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate(redirect);
  };


  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-top">
          <img
            src={buildThemeAssetUrl(themeData?.logo)}
            alt="J"
            className="user-rules-image"
          />
        </div>
        <div className="user-rules-bottom">
          {/* <div className="user-rules-big-title">{themeData?.main_title}</div>
          <div className="user-rules-subline">
            {themeData?.landing_page_title}
          </div> */}
          <div className="user-rules-heading" style={{
            ...(themeData?.button_color && { backgroundColor: themeData.button_color }),
            ...(themeData?.button_text_color && { color: themeData.button_text_color }),
          }}>Rules</div>
          <ul className="user-rules-list">
            {
              themeData?.rules.map((rules, index) => (
                <li key={index} style={{color: themeData.text_color}}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button style={{
              ...(themeData?.button_color && { backgroundColor: themeData.button_color }),
              ...(themeData?.button_text_color && { color: themeData.button_text_color }),
            }}
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserRules;